import { SECOND_BAGGAGE } from '../products';
import getGraphQlSelection from './getGraphQlSelection';
const formSection = SECOND_BAGGAGE.name;
const secondBaggagePerTraveler = {
  getGraphQlSelection,
  formSection,
  ...SECOND_BAGGAGE
};
export default secondBaggagePerTraveler;